import { FormControl, FormField, FormItem, FormLabel, FormMessage, FormDescription } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from "react-hook-form";
import { Gift, Target, Heart, AlertCircle } from "lucide-react";

interface OffersStepProps {
  form: UseFormReturn<any>;
}

const OffersStep = ({ form }: OffersStepProps) => {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="space-y-2">
        <h2 className="text-2xl font-semibold flex items-center gap-2">
          <Gift className="w-6 h-6 text-primary" />
          Offerte e Collaborazione
        </h2>
        <p className="text-muted-foreground">Parliamo delle tue offerte e aspettative</p>
      </div>

      <FormField
        control={form.control}
        name="currentOffer"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Offerta Attuale o Pianificata - Es. Prima seduta a 29€, pacchetto 5 sedute a prezzo scontato, ecc.</FormLabel>
            <FormControl>
              <Textarea
                placeholder="Descrivi un'offerta che hai testato, stai usando o vorresti lanciare..."
                className="resize-none min-h-[100px]"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="reasonForCollaboration"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-2">
              <Heart className="w-4 h-4" />
              Motivo della Collaborazione *
            </FormLabel>
            <FormControl>
              <Textarea
                placeholder="Cosa ti ha spinto a scegliere di collaborare con noi?"
                className="resize-none min-h-[100px]"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="expectations"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-2">
              <Target className="w-4 h-4" />
              Aspettative - Sii specifico: es. aumentare clienti del 30%, riempire agenda, posizionamento online *
            </FormLabel>
            <FormControl>
              <Textarea
                placeholder="Quali sono le tue principali aspettative rispetto a questa collaborazione?"
                className="resize-none min-h-[100px]"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="doubts"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-2">
              <AlertCircle className="w-4 h-4" />
              Dubbi o Timori - La tua sincerità ci aiuta a servirti meglio
            </FormLabel>
            <FormControl>
              <Textarea
                placeholder="Quali dubbi o timori avevi prima di iniziare questo percorso con noi?"
                className="resize-none"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <div className="mt-8 p-6 bg-gradient-to-r from-primary/10 to-secondary/10 rounded-lg border border-primary/20">
        <h3 className="font-semibold mb-2 flex items-center gap-2">
          <Sparkles className="w-5 h-5 text-primary" />
          Ultimo Passaggio!
        </h3>
        <p className="text-sm text-muted-foreground">
          Hai compilato tutte le sezioni. Clicca su "Invia Modulo" per completare il questionario.
        </p>
      </div>
    </div>
  );
};

const Sparkles = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M12 3v18m9-9H3" />
  </svg>
);

export default OffersStep;
